module.exports = __webpack_public_path__ + "img/mosconeWhite.1568b54b.svg";